// libs/version/SamsonVersion.ts
export type SamsonVersionPatchNotes = {
    [patchNote: string]: {
        timestamp: Date; // Time of the patch
        notes: string[]; // Note for the patch
    }
}

export const SAMSON_VERSION_PATCH_NOTES: SamsonVersionPatchNotes = {
    '2.1.6': {
        timestamp: new Date("2026-11-04 00:00"),
        notes: ["many things again"
        ],
    }, 
    '2.1.5': {
        timestamp: new Date("2026-10-28 00:00"),
        notes: ["many things again"
        ],
    }, 
    '2.1.4': {
        timestamp: new Date("2026-10-20 00:00"),
        notes: ["many things again"
        ],
    }, 
    '2.1.3': {
        timestamp: new Date("2026-10-14 00:00"),
        notes: ["many things again"
        ],
    },  
    '2.1.2': {
        timestamp: new Date("2026-10-08 00:00"),
        notes: ["many things again"
        ],
    },  
    '2.1.1': {
        timestamp: new Date("2026-10-01 00:00"),
        notes: ["many things again"
        ],
    },  
    '2.1.0': {
        timestamp: new Date("2026-10-01 00:00"),
        notes: ["many things again"
        ],
    },    
    '2.0.9': {
        timestamp: new Date("2026-09-23 00:00"),
        notes: ["many things"
        ],
    }, 
    '2.0.8': {
        timestamp: new Date("2026-09-07 00:00"),
        notes: ["medical documentation"
        ],
    },    
    '2.0.7': {
        timestamp: new Date("2026-08-04 00:00"),
        notes: ["invoice sending, app calendar view"
        ],
    },
    '2.0.6': {
        timestamp: new Date("2026-08-04 00:00"),
        notes: ["blocked emails, beratung practitioners"
        ],
    },
    '2.0.5': {
        timestamp: new Date("2026-07-24 00:00"),
        notes: ["shift planning improvements, academy type and appointment types"
        ],
    },
    '2.0.4': {
        timestamp: new Date("2026-07-09 00:00"),
        notes: ["shift planning improvements, academy type and appointment types"
        ],
    },
    '2.0.3': {
        timestamp: new Date("2026-06-18 00:00"),
        notes: ["goa update, waitlist call tracking, deeplink for practitioners,"
        ],
    },
    '2.0.2': {
        timestamp: new Date("2026-06-16 00:00"),
        notes: ["shift planning stuff"
        ],
    },
    '2.0.1': {
        timestamp: new Date("2026-06-05 00:00"),
        notes: ["Billing Module Bug Fixes"
        ],
    },
    '2.0.0': {
        timestamp: new Date("2026-06-01 00:00"),
        notes: ["Billing Module"
        ],
    },
    '1.2.3': {
        timestamp: new Date("2026-03-13 11:53"),
        notes: [
        ],
    },
    '1.2.2': {
        timestamp: new Date("2026-02-11 20:42"),
        notes: [
        ],
    },
    '1.2.1': {
        timestamp: new Date("2026-01-19 16:20"),
        notes: [
        ],
    },
    '1.2.0': {
        timestamp: new Date("2025-11-20 17:56"),
        notes: [
        ],
    },
    '1.1.9': {
        timestamp: new Date("2025-11-14 09:45"),
        notes: [
        ],
    },
    '1.1.8': {
        timestamp: new Date("2025-11-06 22:05"),
        notes: [
        ],
    },
    '1.1.7': {
        timestamp: new Date("2025-11-03 10:07"),
        notes: [
        ],
    },
    '1.1.6': {
        timestamp: new Date("2025-09-08 19:11"),
        notes: [
        ],
    },
    '1.1.5': {
        timestamp: new Date("2025-09-04 09:00"),
        notes: [
        ],
    },
    '1.1.4': {
        timestamp: new Date("2025-08-11 10:25"),
        notes: [
        ],
    },
    '1.1.3': {
        timestamp: new Date("2025-07-21 13:55"),
        notes: [
        ],
    },
    '1.1.2': {
        timestamp: new Date("2025-07-10 16:59"),
        notes: [
        ],
    },
    '1.1.1': {
        timestamp: new Date("2025-07-01 23:08"),
        notes: [
        ],
    },
    '1.1.0': {
        timestamp: new Date("2025-06-26 10:44"),
        notes: [
            "Waitlist functionality in booking funnel.",
            "Many additions and changes to GHL webhook triggers",
            "Removed 2 hour buffer in Samson timeslot finder",
        ],
    },
    '1.0.9': {
        timestamp: new Date("2025-06-25 20:38"),
        notes: [
            "Waitlist functionality in booking funnel.",
            "Many additions and changes to GHL webhook triggers",
            "Removed 2 hour buffer in Samson timeslot finder",
        ],
    },
    '1.0.8': {
        timestamp: new Date("2025-06-10 12:00"),
        notes: [
            "Added a new option to blockers: Only block for the original practitioner/equipment. This is useful when you want to block for a specific practitioner, but not for the other practitioners in the group.",
            "Moved color picker to the bottom of appointment slider",
            "Changed text color of disabled inputs in appointment slider to be more visible",
            "Added a list of selected variants to the very top of the appointment slider",
            "Made X button in appointment slider bigger",
            "Made appointment view button in the board bigger",
            "Blockers and availabilities that are grouped together can now be modified on a per-practitioner level.",
            "Recurring blockers and availabilities that are grouped together can now be changed for specific days, while keeping the recurring rule the same elsewhere.",
        ],
    },
    '1.0.7': {
        timestamp: new Date("2025-06-04 13:20"),
        notes: [
            "Added subcolumns to board view: For 'today', Incoming, delayed, noshow; for arrived in Berlin, Upstairs and downstairs; for finalizing, finalizing and completed.",
            "Added tags to board view when customers have finished doing their skin scan.",
            "Added links to open the customer in Praxismanager. This can currently be done by the customer's name and by email, since it is through a search feature in PM and not perfect at the moment.",
            "Added busy timelots data and percentage timeslots data to analytics page",
        ],
    },
    '1.0.6': {
        timestamp: new Date("2025-05-19 20:52"),
        notes: [
            "Added board page for managing appointments on today's date.",
            "Added doctor treatment documentation functionality to appointments.",
            "Fixed issue with future phone numbers not being correctly linked to a customer in GoHighLevel.",
            "Added analytics page.",
        ],
    },
    '1.0.5': {
        timestamp: new Date("2025-05-18 09:01"),
        notes: [
            "Fixed a visual glitch in Termine where short event items in the calendar would visually overlap with other event items even when they don't have overlapping times.",
            "Improved readability for descriptive text on Blockers.",
            "Logs can be accessed for all users, instead of only for admins.",
            "Fixed an issue where incoming appointment requests would show archived appointments. It will no longer do this.",
            "Changed red and orange color picker colors for appointments to lighter, less dominant colors.",
            "When creating or editing an appointment, changed input text color of 'Nachricht Senden' and 'Termin-Notiz (intern)' to orange for better visibility.",
            "Fixed Termine filtering for 3-week view and week view.",
            "Made it so you can create blockers for groups of practitioners or devices.",
            "Reworked availability and blocker layout for Behandler Verfügbarkeit Practitioner Schedule page.",
            "Made blockers gray instead of red."
        ],
    },
    '1.0.4': {
        timestamp: new Date("2025-05-12 11:44"),
        notes: [
            "Popup warning when setting appointments to canceled or declined.",
            "Blockers for practitioners and devices can now be set to be recurring from the Termine.",
            "You can now decide if the customer should be sent a notification when creating and updating appointments.",
            "You can now filter by the practitioner in the timeslot finder.",
            "You can now search customers by their phone number with 0 and +49 interchangable.",
            "Added global search bar for searching customers and their appointments.",
            "Made it so you can see how much time it was since the customer made an appointment request.",
            "Deleting an appointment no longer cancels it and no longer sends the customer a notification. Deleting should only be done if a mistake was made.",
            "Incoming appointment requests are now sorted to show them ordered by which ones are coming up soonest.",
            "Deleted appointments no longer shows up in a customer's appointment history.",
        ]
    },
    '1.0.3': {
        timestamp: new Date("2025-05-10 17:51"),
        notes: [
            "When creating a new blocker, it will now default to the current date in Termine",
            "Added text on blockers in Termine to describe what the blocker is without having to hover with the mouse.",
            "Add 'Empfang' column to Termine.",
            "Rework the user page and add some permission checks on Termine->Store selection, and on the navigation menu.",
            "Add email notification fields data for locationShortcode, voucherCode, startDate.",
        ]
    },
    '1.0.2': {
        timestamp: new Date("2025-05-09 12:18"),
        notes: [
            "When manually creating or editing an appointment, you can now see missing resources on each step",
            "When selecting a resource to assign to an appointment step, it will tell you if it is available, and if it is a practitioner it will also tell you if the practitioner can perform this.",
            "When the last treatment step is deleted from an appointment, the treatment badge will also now be removed from the appointment automatically.",
            "Display clinic names that a customer has had appointments in on the Kunden page",
            "Display clinic names for customer's past appointments on the Termine page",
            "Bug fix when deleting blockers.",
            "You can now see when a practitioner is double-booked while creating or editing an appointment"
        ]
    },
    '1.0.1': {
        timestamp: new Date("2025-05-07 19:15"),
        notes: [
            "Imported existing payments from Shore into Samson, stored on customer notes.",
            "Display name of user in the top-right corner.",
            "Success popup when creating/modifying an appointment.",
            "€0 now displays as '/' in customer emails.",
        ]
    },
    '1.0.0': {
        timestamp: new Date("2025-05-07 16:57"),
        notes: [
            "First Samson patch note!",
        ],
    },
}

// Fix the sorting logic to get the latest version (not the earliest)
export const CURRENT_SAMSON_VERSION = Object.keys(SAMSON_VERSION_PATCH_NOTES)
    .sort((a, b) => parseInt(b.replaceAll(".", "")) - parseInt(a.replaceAll(".", "")))
[0];
export const CURRENT_SAMSON_VERSION_TIMESTAMP = SAMSON_VERSION_PATCH_NOTES[CURRENT_SAMSON_VERSION].timestamp;

// Add a default export as well
export default {
    CURRENT_SAMSON_VERSION,
    SAMSON_VERSION_PATCH_NOTES
};